class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.observer = null;
  }

  connectedCallback() {
    if (this.shouldLoadImmediately()) {
      this.loadScripts();
      return;
    }

    this.observeLoadTarget();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  shouldLoadImmediately() {
    if (this.dataset.loadStrategy !== 'viewport') return true;
    if (document.getElementById('PageContainer')?.dataset.editorOpen === 'true') return true;
    if (window.Shopify?.designMode) return true;
    return typeof IntersectionObserver === 'undefined';
  }

  observeLoadTarget() {
    const loadTarget = this.closest('[id^="shopify-section-"]') || this.parentElement || this;
    const rootMargin = this.dataset.loadRootMargin || '900px 0px';

    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      this.loadScripts();
      this.observer?.disconnect();
      this.observer = null;
    }, {
      rootMargin,
      threshold: 0.01
    });

    this.observer.observe(loadTarget);
  }

  loadScripts() {
    if (this.loaded) return;
    this.loaded = true;

    const scripts = this.querySelectorAll(':scope > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey || script.dataset.envyLoadKey;
      const src = script.src;

      const scriptLoaded = key && window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      const scriptAlreadyRequested = src && SafeLoadScripts.requestedScripts.has(src);
      if(!scriptLoaded && !scriptAlreadyRequested) {
        const postLoadedScript = document.createElement('script');
        Array.from(script.attributes).forEach((attribute) => {
          postLoadedScript.setAttribute(attribute.name, attribute.value);
        });

        if (src) SafeLoadScripts.requestedScripts.add(src);
        (this.parentElement || document.body).appendChild(postLoadedScript);
      }
    })
  }
}

SafeLoadScripts.requestedScripts = new Set();
  
customElements.define('safe-load-scripts', SafeLoadScripts);
